import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import Analytics from '../../../analytics';
import PreSettingDone from '../../templates/pre-setting-done';
import EntryListItem from './entry-list-item';
import SubTitle from '../../atoms/sub-title';
import { Spinner } from '@graffer-inc/graffer-ui';
import {connect} from "react-redux";
import Http from "../../../http";
import {setEntries} from "../../../redux/modules/user";

const Main = ({ entries, setEntries }) => {
  useEffect(() => {
    const fetchEntries = async () => await Http.fetchEntries(res => setEntries(res.data.entries));
    fetchEntries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <PreSettingDone>
      <div className="container">
        <div className="columns is-centered">
        <div className="column is-8">
          <p className="is-size-3 has-text-weight-bold">ホーム</p>
          <div className="has-text-centered" style={{padding: '20px 0 0 0'}}>
            <Link
              to="/entries/new"
              className="button is-accent is-rounded is-fullwidth"
              onClick={() => Analytics.homeToEntryNew(entries.length === 0)}
            >
              取得サポートを申し込む
            </Link>
          </div>
          <br/>
          <br/>
          <SubTitle>お申し込み一覧</SubTitle>
          {
            !entries ? (
              <div className="has-text-centered">
                <Spinner />
              </div>
            ) : entries.length === 0 ? (
              <div className="has-text-centered">
                <p className="has-text-weight-bold has-text-grey">過去のお申し込みはありません。</p>
              </div>
            ) : (
              entries.map(e => (
                <EntryListItem
                  entry={e}
                  key={e.id}
                />
              ))
            )
          }
        </div>
        </div>
      </div>
    </PreSettingDone>
  )
};

export default connect(
  store => ({ entries: store.user.entries }),
  {setEntries}
)(Main);